import dayjs from 'dayjs';
const DEFAULT_AMAZON_GIFT_PRICE = 1500;
export class FriendInvitationCampaign {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "endAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "paymentImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lpHeaderImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amazonGiftPrice_", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amazonGiftEndAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.startAt = data.startAt;
        this.endAt = data.endAt;
        this.paymentImageSrc = data.paymentImageUrl;
        this.lpHeaderImageSrc = data.lpHeaderImageUrl;
        this.amazonGiftPrice_ = data.amazonGiftPrice;
        this.amazonGiftEndAt = data.amazonGiftEndAt;
        this.config = config;
    }
    get isHolding() {
        const now = dayjs().unix();
        return this.startAt <= now && now < this.endAt;
    }
    get paymentImageURL() {
        return this.paymentImageSrc ? this.config.cdnBaseURL + this.paymentImageSrc : undefined;
    }
    get lpHeaderImageURL() {
        return this.lpHeaderImageSrc ? this.config.cdnBaseURL + this.lpHeaderImageSrc : undefined;
    }
    get amazonGiftPrice() {
        return this.isHolding ? this.amazonGiftPrice_ : DEFAULT_AMAZON_GIFT_PRICE;
    }
    get endAtStr() {
        return dayjs.unix(this.endAt).format('M/D');
    }
    get periodStr() {
        return `${dayjs.unix(this.startAt).format('M/D')} ~ ${dayjs.unix(this.endAt).format('M/D')}`;
    }
    get amazonGiftCampaignIsAvailable() {
        return this.amazonGiftEndAt > dayjs().unix();
    }
}
